export const formatTime = (seconds) => {
  if (!seconds || isNaN(seconds)) return "0s";

  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  let result = "";
  if (hrs > 0) result += `${hrs}hr${hrs > 1 ? "s" : ""} `;
  if (mins > 0) result += `${mins}min${mins > 1 ? "s" : ""} `;
  if (hrs === 0 && mins === 0) result += `${secs}s`; // only show secs if <1 min

  return result.trim();
}